module.exports = __webpack_public_path__ + "static/media/NavbarBrand.d4fab70f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/NavbarBrand.webp
// module id = 205
// module chunks = 15